import React, { useState, createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, DownloadIcon, ZoomInIcon, ZoomOutIcon, PrinterIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
export const EnglishSuite2Bourree2Viewer: React.FC = () => {
  const navigate = useNavigate();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const [zoom, setZoom] = useState(100);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const pdfUrl = 'https://www.mutopiaproject.org/ftp/BachJS/BWV807/bach-english-suite-2-bourree-2/bach-english-suite-2-bourree-2-a4.pdf';
  const pdfViewUrl = isMobile ? `${pdfUrl}#view=Fit&zoom=page-width` : `${pdfUrl}#view=FitH`;
  const handleZoomIn = () => setZoom(prev => Math.min(prev + 10, 200));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 10, 50));
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Bach - English Suite No. 2 Bourree II BWV 807.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handlePrint = () => {
    window.print();
  };
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gray-50'}`} data-id="element-4112">
      <Navbar data-id="element-4113" />

      <div className="pt-20" data-id="element-4114">
        <div className="relative w-full" style={{
        minHeight: '320px'
      }} data-id="element-4115">
          <img src="https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=1200&h=400&fit=crop" alt="English Suite No. 2 – Bourrée II" className="w-full h-64 md:h-80 object-cover" data-id="element-4116" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black/70" data-id="element-4117" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8" data-id="element-4118">
            <div className="max-w-7xl mx-auto" data-id="element-4119">
              <button onClick={() => navigate(-1)} className="mb-4 flex items-center text-white/90 hover:text-white transition-colors" data-id="element-4120">
                <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-4121" />
                Back to Library
              </button>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2" data-id="element-4122">
                English Suite No. 2 – Bourrée II
              </h1>
              <p className="text-lg md:text-xl text-white/90" data-id="element-4123">BWV 807</p>
              <p className="text-base md:text-lg text-white/80 mt-1" data-id="element-4124">
                Johann Sebastian Bach
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Toolbar */}
      <div className={`sticky top-20 z-10 ${isDark ? 'bg-navy-800/95 backdrop-blur-sm border-b border-white/10' : 'bg-white/95 backdrop-blur-sm border-b border-gray-200'} shadow-sm`} data-id="element-4125">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-4126">
          <div className="flex items-center space-x-2" data-id="element-4127">
            {!isMobile && <>
                <button onClick={handleZoomOut} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white' : 'hover:bg-gray-100 text-gray-800'}`} aria-label="Zoom out" data-id="element-4128">
                  <ZoomOutIcon className="h-5 w-5" data-id="element-4129" />
                </button>
                <span className={`text-sm font-medium px-3 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4130">
                  {zoom}%
                </span>
                <button onClick={handleZoomIn} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white' : 'hover:bg-gray-100 text-gray-800'}`} aria-label="Zoom in" data-id="element-4131">
                  <ZoomInIcon className="h-5 w-5" data-id="element-4132" />
                </button>
              </>}
          </div>
          <div className="flex items-center space-x-2" data-id="element-4133">
            <button onClick={handlePrint} className={`flex items-center justify-center px-4 py-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white border border-navy-700' : 'hover:bg-gray-100 text-gray-800 border border-gray-200'}`} data-id="element-4134">
              <PrinterIcon className="h-4 w-4 sm:mr-2" data-id="element-4135" />
              <span className="hidden sm:inline" data-id="element-4136">Print</span>
            </button>
            <button onClick={handleDownload} className="flex items-center justify-center px-4 py-2 border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500/10 rounded-lg transition-colors" data-id="element-4137">
              <DownloadIcon className="h-4 w-4 sm:mr-2" data-id="element-4138" />
              <span className="hidden sm:inline" data-id="element-4139">Download PDF</span>
            </button>
          </div>
        </div>
      </div>

      {/* Sheet Music Viewer */}
      <main className="max-w-7xl mx-auto px-4 py-8" data-id="element-4140">
        <div className={`rounded-xl overflow-hidden shadow-lg ${isDark ? 'bg-navy-800' : 'bg-white'}`} data-id="element-4141">
          <div className="w-full" style={{
          height: 'calc(100vh - 300px)',
          minHeight: '600px'
        }} data-id="element-4142">
            <iframe src={pdfViewUrl} className="w-full h-full" title="English Suite No. 2 – Bourrée II Sheet Music" style={{
            border: 'none',
            ...(isMobile ? {} : {
              transform: `scale(${zoom / 100})`,
              transformOrigin: 'top center',
              transition: 'transform 0.2s ease'
            })
          }} data-id="element-4143" />
          </div>
        </div>

        {/* Piece Information */}
        <div className={`mt-8 rounded-xl p-6 ${isDark ? 'bg-navy-800' : 'bg-white'} shadow-sm`} data-id="element-4144">
          <h2 className={`text-2xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4145">
            About This Piece
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-4146">
            <div data-id="element-4147">
              <h3 className={`text-lg font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4148">
                Composition Details
              </h3>
              <dl className="space-y-2" data-id="element-4149">
                <div data-id="element-4150">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-4151">
                    Composer
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4152">
                    Johann Sebastian Bach
                  </dd>
                </div>
                <div data-id="element-4153">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-4154">
                    Catalog
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4155">
                    BWV 807
                  </dd>
                </div>
                <div data-id="element-4156">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-4157">
                    Instrument
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4158">
                    Piano (Harpsichord)
                  </dd>
                </div>
                <div data-id="element-4159">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-4160">
                    Collection
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4161">
                    English Suite No. 2 in A Minor
                  </dd>
                </div>
              </dl>
            </div>
            <div data-id="element-4162">
              <h3 className={`text-lg font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-4163">
                Performance Notes
              </h3>
              <p className={`text-sm leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-4164">
                The Bourrée II from Bach's English Suite No. 2 in A Minor (BWV
                807) offers a contrasting character to Bourrée I, often written
                in A major to provide harmonic relief before the return of the
                minor-key first bourrée. This interplay between major and minor
                creates a compelling emotional arc. The movement exemplifies
                Bach's ability to craft meaningful contrast within a compact
                formal structure, making the da capo return of Bourrée I all the
                more satisfying.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-4165" />
    </div>;
};